<template>
  <div class="taste-notes">
    <div
      v-for="(note, index) of notes"
      :key="index"
      class="taste-notes__item"
    >
      <p
        class="text-other-label-s"
        v-text="note.key"
      />
      <p
        v-if="note.key === 'flavor'"
        class="text-body-s-regular taste-notes__italic"
        v-text="note.note"
      />
      <div
        v-else
        class="taste-notes__details"
      >
        <p
          class="text-body-xs-regular"
          v-text="noteLabels[note.key]?.start"
        />
        <div class="taste-notes__levels">
          <div
            v-for="number of 5"
            :key="number"
            class="taste-notes__levels--item"
            :class="{ [$class('active')]: number <= note.note }"
          >
            <icon-ellipse />
          </div>
        </div>
        <p
          class="text-body-xs-regular taste-notes__levels--label"
          v-text="noteLabels[note.key]?.end"
        />
      </div>
    </div>
  </div>
</template>

<script>

/**
 * Vue: Taste notes (taste-notes)
 * -----------------------------------------------------------------------------
 * Taste notes details.
 * - Component settings: snippet / dynamic / async / scroll
 * @param {Array} [notes] - Array of taste notes.
 *
 */
import IconEllipse from '~icons/general/ellipse.svg'

export default {
  name: 'TasteNotes',

  components: { IconEllipse },

  props: {
    notes: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      noteLabels: {
        color: {
          start: this.$string('product.taste_notes.light'),
          end: this.$string('product.taste_notes.dark'),
        },
        texture: {
          start: this.$string('product.taste_notes.soft'),
          end: this.$string('product.taste_notes.firm'),
        },
        intensity: {
          start: this.$string('product.taste_notes.light'),
          end: this.$string('product.taste_notes.roboust'),
        },
        size: {
          start: this.$string('product.taste_notes.small'),
          end: this.$string('product.taste_notes.large'),
        },
      },
    }
  },
}
</script>

<style lang="scss">
@import './taste-notes';
</style>
